import { createSlice } from "@reduxjs/toolkit";
import {
  getAreasDesarrolloPlantelThunk,
  getAreaDesarrolloPlantelByIdThunk,
  updateAreaDesarrolloPlantelThunk,
  toggleAreaDesarrolloPlantelActiveThunk,
  getAccionesDesarrolloPlantelThunk,
  getAccionDesarrolloPlantelByIdThunk,
  updateAccionDesarrolloPlantelThunk,
  toggleAccionDesarrolloPlantelActiveThunk,
  createMultiplesAccionesPlantelThunk,
} from "./fortalezasPlantel.thunks";

const initialState = {
  // --- Áreas de Desarrollo ---
  areasList: [],
  areasLoading: false,
  areasError: null,
  areasPage: 1,
  areasPageSize: 10,
  areasCount: 0,
  areasMaxPageReached: 1,
  areasSearch: "",

  selectedArea: null,
  selectedAreaLoading: false,
  selectedAreaError: null,
  areaViewModalOpen: false,

  areaFormModalOpen: false,
  areaFormLoading: false,
  areaFormError: null,

  areaConfirmModalOpen: false,
  toggleAreaId: null,
  areaToggling: false,

  // --- Acciones de Desarrollo ---
  accionesList: [],
  accionesLoading: false,
  accionesError: null,
  accionesPage: 1,
  accionesPageSize: 10,
  accionesCount: 0,
  accionesMaxPageReached: 1,
  accionesSearch: "",
  accionesFilterArea: "",
  accionesFilterTalento: "",

  selectedAccion: null,
  selectedAccionLoading: false,
  selectedAccionError: null,
  accionViewModalOpen: false,

  accionFormModalOpen: false,
  accionFormMode: "edit",
  accionFormLoading: false,
  accionFormError: null,

  accionMultiplesModalOpen: false,
  accionMultiplesLoading: false,
  accionMultiplesError: null,

  accionConfirmModalOpen: false,
  toggleAccionId: null,
  accionToggling: false,
};

const fortalezasPlantelSlice = createSlice({
  name: "fortalezasPlantel",
  initialState,
  reducers: {
    resetFortalezasPlantel: () => initialState,

    // --- Áreas ---
    clearAreasError: (state) => { state.areasError = null; },
    setAreasPage: (state, action) => { state.areasPage = action.payload; },
    setAreasSearch: (state, action) => { state.areasSearch = action.payload; state.areasPage = 1; },
    openAreaViewModal: (state) => { state.areaViewModalOpen = true; },
    closeAreaViewModal: (state) => { state.areaViewModalOpen = false; state.selectedArea = null; },
    openAreaFormModal: (state) => { state.areaFormModalOpen = true; state.areaFormError = null; },
    closeAreaFormModal: (state) => { state.areaFormModalOpen = false; state.selectedArea = null; state.areaFormError = null; },
    openAreaConfirmToggle: (state, action) => { state.areaConfirmModalOpen = true; state.toggleAreaId = action.payload.id; },
    closeAreaConfirmToggle: (state) => { state.areaConfirmModalOpen = false; state.toggleAreaId = null; },

    // --- Acciones ---
    clearAccionesError: (state) => { state.accionesError = null; },
    setAccionesPage: (state, action) => { state.accionesPage = action.payload; },
    setAccionesSearch: (state, action) => { state.accionesSearch = action.payload; state.accionesPage = 1; },
    setAccionesFilterArea: (state, action) => { state.accionesFilterArea = action.payload; state.accionesPage = 1; },
    setAccionesFilterTalento: (state, action) => { state.accionesFilterTalento = action.payload; state.accionesPage = 1; },
    clearAccionesFilters: (state) => { state.accionesSearch = ""; state.accionesFilterArea = ""; state.accionesFilterTalento = ""; state.accionesPage = 1; },
    openAccionViewModal: (state) => { state.accionViewModalOpen = true; },
    closeAccionViewModal: (state) => { state.accionViewModalOpen = false; state.selectedAccion = null; },
    openAccionFormModal: (state, action) => { state.accionFormModalOpen = true; state.accionFormMode = action.payload?.mode || "edit"; state.accionFormError = null; },
    closeAccionFormModal: (state) => { state.accionFormModalOpen = false; state.selectedAccion = null; state.accionFormError = null; },
    openAccionMultiplesModal: (state) => { state.accionMultiplesModalOpen = true; state.accionMultiplesError = null; },
    closeAccionMultiplesModal: (state) => { state.accionMultiplesModalOpen = false; state.accionMultiplesError = null; },
    openAccionConfirmToggle: (state, action) => { state.accionConfirmModalOpen = true; state.toggleAccionId = action.payload.id; },
    closeAccionConfirmToggle: (state) => { state.accionConfirmModalOpen = false; state.toggleAccionId = null; },
  },
  extraReducers: (builder) => {
    builder
      // ========== ÁREAS ==========
      .addCase(getAreasDesarrolloPlantelThunk.pending, (state) => { state.areasLoading = true; state.areasError = null; })
      .addCase(getAreasDesarrolloPlantelThunk.fulfilled, (state, action) => {
        const { results, count } = action.payload;
        state.areasLoading = false;
        state.areasList = results;
        state.areasCount = count;
        state.areasMaxPageReached = Math.max(state.areasMaxPageReached, state.areasPage);
      })
      .addCase(getAreasDesarrolloPlantelThunk.rejected, (state, action) => { state.areasLoading = false; state.areasError = action.payload; })
      .addCase(getAreaDesarrolloPlantelByIdThunk.pending, (state) => { state.selectedAreaLoading = true; state.selectedAreaError = null; })
      .addCase(getAreaDesarrolloPlantelByIdThunk.fulfilled, (state, action) => { state.selectedAreaLoading = false; state.selectedArea = action.payload; })
      .addCase(getAreaDesarrolloPlantelByIdThunk.rejected, (state, action) => { state.selectedAreaLoading = false; state.selectedAreaError = action.payload; })
      .addCase(updateAreaDesarrolloPlantelThunk.pending, (state) => { state.areaFormLoading = true; state.areaFormError = null; })
      .addCase(updateAreaDesarrolloPlantelThunk.fulfilled, (state, action) => {
        state.areaFormLoading = false;
        const idx = state.areasList.findIndex((a) => a.id === action.payload.id);
        if (idx !== -1) state.areasList[idx] = action.payload;
        state.areaFormModalOpen = false;
      })
      .addCase(updateAreaDesarrolloPlantelThunk.rejected, (state, action) => { state.areaFormLoading = false; state.areaFormError = action.payload; })
      .addCase(toggleAreaDesarrolloPlantelActiveThunk.pending, (state) => { state.areaToggling = true; })
      .addCase(toggleAreaDesarrolloPlantelActiveThunk.fulfilled, (state, action) => {
        state.areaToggling = false;
        state.areaConfirmModalOpen = false;
        const idx = state.areasList.findIndex((a) => a.id === action.payload.id);
        if (idx !== -1) state.areasList[idx] = action.payload;
      })
      .addCase(toggleAreaDesarrolloPlantelActiveThunk.rejected, (state, action) => { state.areaToggling = false; state.areasError = action.payload; })

      // ========== ACCIONES ==========
      .addCase(getAccionesDesarrolloPlantelThunk.pending, (state) => { state.accionesLoading = true; state.accionesError = null; })
      .addCase(getAccionesDesarrolloPlantelThunk.fulfilled, (state, action) => {
        const { results, count } = action.payload;
        state.accionesLoading = false;
        state.accionesList = results;
        state.accionesCount = count;
        state.accionesMaxPageReached = Math.max(state.accionesMaxPageReached, state.accionesPage);
      })
      .addCase(getAccionesDesarrolloPlantelThunk.rejected, (state, action) => { state.accionesLoading = false; state.accionesError = action.payload; })
      .addCase(getAccionDesarrolloPlantelByIdThunk.pending, (state) => { state.selectedAccionLoading = true; state.selectedAccionError = null; })
      .addCase(getAccionDesarrolloPlantelByIdThunk.fulfilled, (state, action) => { state.selectedAccionLoading = false; state.selectedAccion = action.payload; })
      .addCase(getAccionDesarrolloPlantelByIdThunk.rejected, (state, action) => { state.selectedAccionLoading = false; state.selectedAccionError = action.payload; })
      .addCase(updateAccionDesarrolloPlantelThunk.pending, (state) => { state.accionFormLoading = true; state.accionFormError = null; })
      .addCase(updateAccionDesarrolloPlantelThunk.fulfilled, (state, action) => {
        state.accionFormLoading = false;
        const idx = state.accionesList.findIndex((a) => a.id === action.payload.id);
        if (idx !== -1) state.accionesList[idx] = action.payload;
        state.accionFormModalOpen = false;
      })
      .addCase(updateAccionDesarrolloPlantelThunk.rejected, (state, action) => { state.accionFormLoading = false; state.accionFormError = action.payload; })
      .addCase(toggleAccionDesarrolloPlantelActiveThunk.pending, (state) => { state.accionToggling = true; })
      .addCase(toggleAccionDesarrolloPlantelActiveThunk.fulfilled, (state, action) => {
        state.accionToggling = false;
        state.accionConfirmModalOpen = false;
        const idx = state.accionesList.findIndex((a) => a.id === action.payload.id);
        if (idx !== -1) state.accionesList[idx] = action.payload;
      })
      .addCase(toggleAccionDesarrolloPlantelActiveThunk.rejected, (state, action) => { state.accionToggling = false; state.accionesError = action.payload; })
      .addCase(createMultiplesAccionesPlantelThunk.pending, (state) => { state.accionMultiplesLoading = true; state.accionMultiplesError = null; })
      .addCase(createMultiplesAccionesPlantelThunk.fulfilled, (state) => { state.accionMultiplesLoading = false; state.accionMultiplesModalOpen = false; })
      .addCase(createMultiplesAccionesPlantelThunk.rejected, (state, action) => { state.accionMultiplesLoading = false; state.accionMultiplesError = action.payload; });
  },
});

export const {
  resetFortalezasPlantel,
  clearAreasError, setAreasPage, setAreasSearch,
  openAreaViewModal, closeAreaViewModal,
  openAreaFormModal, closeAreaFormModal,
  openAreaConfirmToggle, closeAreaConfirmToggle,
  clearAccionesError, setAccionesPage, setAccionesSearch,
  setAccionesFilterArea, setAccionesFilterTalento, clearAccionesFilters,
  openAccionViewModal, closeAccionViewModal,
  openAccionFormModal, closeAccionFormModal,
  openAccionMultiplesModal, closeAccionMultiplesModal,
  openAccionConfirmToggle, closeAccionConfirmToggle,
} = fortalezasPlantelSlice.actions;

export default fortalezasPlantelSlice.reducer;
